/**
 * 图片URL处理工具函数
 */

/**
 * 获取完整的图片URL
 * @param {string} url - 图片URL或路径
 * @returns {string} 完整的图片URL
 */
export const getImageUrl = (url) => {
  // 如果URL为空或未定义，返回默认头像
  if (url == "" || url == null || url == undefined) {
    return "https://admin.sanhsf.com/images/default_avatar.jpg";
  }

  // 如果已经是完整的HTTP/HTTPS链接，直接返回
  if (url && url.startsWith("http")) {
    return url;
  }

  // 图片资源使用完整的服务器地址
  const baseURL = "https://appapi.sanhsf.com";
  return `${baseURL}/admin/sys-file/local/${url}`;
};
